<template>
  <div class="user-management-container">
      <div class="image__preview">
        <el-image 
            class="qrcode-img"
            :src="srcList[0]" 
            :preview-src-list="srcList">
        </el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChessManager',
  data() {
    return {
        srcList: ['https://qbox.yeahotel.com/FpfYaIHRIM5UXqfnF8JxvTFyopZy']
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.image__preview {
    padding: 20px 64px;
}
.qrcode-img {
    width: 220px;
    height: 220px;
}
</style>
